// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1j2Bs","load6":"Loader_load6__1MOmG","round":"Loader_round__2U8xM"};